import React, { Fragment } from 'react';

import skyport1 from '../../../../../images/skyport1.jpg';
import skyport2 from '../../../../../images/skyport2.jpg';
import skyport3 from '../../../../../images/skyport3.jpg';
import skyport4 from '../../../../../images/skyport4.jpg';
import skyport5 from '../../../../../images/skyport5.jpg';
import skyport6 from '../../../../../images/skyport6.jpg';
import skyport7 from '../../../../../images/skyport7.png';

const SkyportParking = () => (
  <Fragment>
    <div>
      <img
        className="faq-image-compress"
        src={skyport1}
        alt="Parking Lot"
      />
      <p>Enter the parking lot through the main entrance</p>
    </div>
    <div>
      <img
        className="faq-image-compress"
        src={skyport2}
        alt="Parking Lot"
      />
      <p className="faq-content-width">
        Use the touch screen to get a parking ticket and the gate will
        open.
        <b>
          {' '}
          Don’t worry, you will not pay for parking if you have a valid
          booking.
        </b>
      </p>
    </div>
    <div>
      <img
        className="faq-image-compress"
        src={skyport3}
        alt="Parking Lot"
      />
      <img
        className="faq-image-compress"
        src={skyport4}
        alt="Parking Lot"
      />
      <p>Follow the Autzu parking signage to the 3rd floor</p>
    </div>
    <div>
      <img
        className="faq-image-compress"
        src={skyport5}
        alt="Parking Lot"
      />
      <p className="faq-content-width">
        You must only park your car in the parking spot stated on your
        Autzu Dashboard for your booking.
      </p>
    </div>
    <div>
      <img
        className="faq-image-compress"
        src={skyport6}
        alt="Parking Lot"
      />
      <p className="faq-content-width">
        Upon exit, give your parking ticket to the 24-hour Quik Park
        parking lot associate{' '}
      </p>
    </div>
    <div>
      <img
        className="faq-image-compress"
        src={skyport7}
        alt="Parking Lot"
      />
      <p className="faq-content-width">
        Show proof of your valid booking at{' '}
        <a
          className="faq__panel--link"
          href="https://www.autzu.com/mybookings"
          target="_blank">
          www.autzu.com/mybookings
        </a>{' '}
        so they can waive the parking costs and permit you to exit.
      </p>
    </div>
  </Fragment>
);

export default SkyportParking;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/ParkingLotData/Skyport/SkyportParking.js